"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.from.js");
require("core-js/modules/es.array.index-of.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("core-js/modules/es.array.concat.js");
var _react = _interopRequireWildcard(require("react"));
var _index = require("react-dates/lib/index.js");
require("react-dates/lib/initialize.js");
var _moment = _interopRequireDefault(require("moment"));
var _core = require("../../core");
var _useMedia = _interopRequireWildcard(require("../../hooks/useMedia"));
var _ErrorPrompt = require("../ErrorPrompt");
var _GlobalPortalStyles = require("./GlobalPortalStyles");
var _excluded = ["isOutOfRange", "customIsOutOfRangeSRMessage", "minDate", "maxDate", "onDateChange", "numberOfMonths", "includeWeekends", "initialDate", "id", "disabled", "invalid", "label", "placeholder", "helperText", "onClose", "onClick", "CustomPortalStyles"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function cov_ot8arpjan() {
  var path = "/__w/code/code/js/packages/bricks/src/complex/DatePicker/DatePicker.tsx";
  var hash = "e7cc423bb0924d239aec5f34a9a25cf9bea038f3";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/complex/DatePicker/DatePicker.tsx",
    statementMap: {
      "0": {
        start: {
          line: 66,
          column: 21
        },
        end: {
          line: 72,
          column: 1
        }
      },
      "1": {
        start: {
          line: 67,
          column: 2
        },
        end: {
          line: 71,
          column: 3
        }
      },
      "2": {
        start: {
          line: 68,
          column: 4
        },
        end: {
          line: 68,
          column: 16
        }
      },
      "3": {
        start: {
          line: 69,
          column: 9
        },
        end: {
          line: 71,
          column: 3
        }
      },
      "4": {
        start: {
          line: 70,
          column: 4
        },
        end: {
          line: 70,
          column: 24
        }
      },
      "5": {
        start: {
          line: 74,
          column: 18
        },
        end: {
          line: 74,
          column: 61
        }
      },
      "6": {
        start: {
          line: 74,
          column: 42
        },
        end: {
          line: 74,
          column: 61
        }
      },
      "7": {
        start: {
          line: 85,
          column: 46
        },
        end: {
          line: 257,
          column: 1
        }
      },
      "8": {
        start: {
          line: 105,
          column: 42
        },
        end: {
          line: 105,
          column: 99
        }
      },
      "9": {
        start: {
          line: 107,
          column: 25
        },
        end: {
          line: 107,
          column: 78
        }
      },
      "10": {
        start: {
          line: 110,
          column: 4
        },
        end: {
          line: 116,
          column: 10
        }
      },
      "11": {
        start: {
          line: 118,
          column: 4
        },
        end: {
          line: 120,
          column: 36
        }
      },
      "12": {
        start: {
          line: 122,
          column: 38
        },
        end: {
          line: 122,
          column: 305
        }
      },
      "13": {
        start: {
          line: 124,
          column: 23
        },
        end: {
          line: 124,
          column: 34
        }
      },
      "14": {
        start: {
          line: 125,
          column: 25
        },
        end: {
          line: 125,
          column: 55
        }
      },
      "15": {
        start: {
          line: 126,
          column: 27
        },
        end: {
          line: 126,
          column: 54
        }
      },
      "16": {
        start: {
          line: 128,
          column: 36
        },
        end: {
          line: 128,
          column: 67
        }
      },
      "17": {
        start: {
          line: 129,
          column: 52
        },
        end: {
          line: 129,
          column: 76
        }
      },
      "18": {
        start: {
          line: 130,
          column: 28
        },
        end: {
          line: 133,
          column: 3
        }
      },
      "19": {
        start: {
          line: 131,
          column: 4
        },
        end: {
          line: 131,
          column: 26
        }
      },
      "20": {
        start: {
          line: 132,
          column: 4
        },
        end: {
          line: 132,
          column: 25
        }
      },
      "21": {
        start: {
          line: 135,
          column: 21
        },
        end: {
          line: 135,
          column: 45
        }
      },
      "22": {
        start: {
          line: 137,
          column: 27
        },
        end: {
          line: 149,
          column: 3
        }
      },
      "23": {
        start: {
          line: 138,
          column: 4
        },
        end: {
          line: 138,
          column: 26
        }
      },
      "24": {
        start: {
          line: 139,
          column: 4
        },
        end: {
          line: 142,
          column: 5
        }
      },
      "25": {
        start: {
          line: 140,
          column: 6
        },
        end: {
          line: 140,
          column: 34
        }
      },
      "26": {
        start: {
          line: 141,
          column: 6
        },
        end: {
          line: 141,
          column: 34
        }
      },
      "27": {
        start: {
          line: 145,
          column: 4
        },
        end: {
          line: 148,
          column: 5
        }
      },
      "28": {
        start: {
          line: 146,
          column: 45
        },
        end: {
          line: 146,
          column: 86
        }
      },
      "29": {
        start: {
          line: 147,
          column: 6
        },
        end: {
          line: 147,
          column: 43
        }
      },
      "30": {
        start: {
          line: 150,
          column: 22
        },
        end: {
          line: 158,
          column: 3
        }
      },
      "31": {
        start: {
          line: 151,
          column: 4
        },
        end: {
          line: 155,
          column: 5
        }
      },
      "32": {
        start: {
          line: 152,
          column: 6
        },
        end: {
          line: 152,
          column: 33
        }
      },
      "33": {
        start: {
          line: 154,
          column: 6
        },
        end: {
          line: 154,
          column: 34
        }
      },
      "34": {
        start: {
          line: 157,
          column: 4
        },
        end: {
          line: 157,
          column: 25
        }
      },
      "35": {
        start: {
          line: 163,
          column: 22
        },
        end: {
          line: 163,
          column: 80
        }
      },
      "36": {
        start: {
          line: 163,
          column: 32
        },
        end: {
          line: 163,
          column: 80
        }
      },
      "37": {
        start: {
          line: 164,
          column: 21
        },
        end: {
          line: 164,
          column: 78
        }
      },
      "38": {
        start: {
          line: 164,
          column: 31
        },
        end: {
          line: 164,
          column: 78
        }
      },
      "39": {
        start: {
          line: 166,
          column: 25
        },
        end: {
          line: 170,
          column: 40
        }
      },
      "40": {
        start: {
          line: 167,
          column: 4
        },
        end: {
          line: 170,
          column: 40
        }
      },
      "41": {
        start: {
          line: 172,
          column: 30
        },
        end: {
          line: 172,
          column: 74
        }
      },
      "42": {
        start: {
          line: 172,
          column: 46
        },
        end: {
          line: 172,
          column: 67
        }
      },
      "43": {
        start: {
          line: 174,
          column: 33
        },
        end: {
          line: 191,
          column: 3
        }
      },
      "44": {
        start: {
          line: 175,
          column: 4
        },
        end: {
          line: 183,
          column: 5
        }
      },
      "45": {
        start: {
          line: 176,
          column: 6
        },
        end: {
          line: 182,
          column: 8
        }
      },
      "46": {
        start: {
          line: 184,
          column: 4
        },
        end: {
          line: 190,
          column: 6
        }
      },
      "47": {
        start: {
          line: 193,
          column: 2
        },
        end: {
          line: 256,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 66,
            column: 21
          },
          end: {
            line: 66,
            column: 22
          }
        },
        loc: {
          start: {
            line: 66,
            column: 81
          },
          end: {
            line: 72,
            column: 1
          }
        },
        line: 66
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 74,
            column: 18
          },
          end: {
            line: 74,
            column: 19
          }
        },
        loc: {
          start: {
            line: 74,
            column: 42
          },
          end: {
            line: 74,
            column: 61
          }
        },
        line: 74
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 85,
            column: 46
          },
          end: {
            line: 85,
            column: 47
          }
        },
        loc: {
          start: {
            line: 104,
            column: 6
          },
          end: {
            line: 257,
            column: 1
          }
        },
        line: 104
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 130,
            column: 28
          },
          end: {
            line: 130,
            column: 29
          }
        },
        loc: {
          start: {
            line: 130,
            column: 74
          },
          end: {
            line: 133,
            column: 3
          }
        },
        line: 130
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 137,
            column: 27
          },
          end: {
            line: 137,
            column: 28
          }
        },
        loc: {
          start: {
            line: 137,
            column: 59
          },
          end: {
            line: 149,
            column: 3
          }
        },
        line: 137
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 150,
            column: 22
          },
          end: {
            line: 150,
            column: 23
          }
        },
        loc: {
          start: {
            line: 150,
            column: 36
          },
          end: {
            line: 158,
            column: 3
          }
        },
        line: 150
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 163,
            column: 22
          },
          end: {
            line: 163,
            column: 23
          }
        },
        loc: {
          start: {
            line: 163,
            column: 32
          },
          end: {
            line: 163,
            column: 80
          }
        },
        line: 163
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 164,
            column: 21
          },
          end: {
            line: 164,
            column: 22
          }
        },
        loc: {
          start: {
            line: 164,
            column: 31
          },
          end: {
            line: 164,
            column: 78
          }
        },
        line: 164
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 166,
            column: 25
          },
          end: {
            line: 166,
            column: 26
          }
        },
        loc: {
          start: {
            line: 167,
            column: 4
          },
          end: {
            line: 170,
            column: 40
          }
        },
        line: 167
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 172,
            column: 40
          },
          end: {
            line: 172,
            column: 41
          }
        },
        loc: {
          start: {
            line: 172,
            column: 46
          },
          end: {
            line: 172,
            column: 67
          }
        },
        line: 172
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 174,
            column: 33
          },
          end: {
            line: 174,
            column: 34
          }
        },
        loc: {
          start: {
            line: 174,
            column: 39
          },
          end: {
            line: 191,
            column: 3
          }
        },
        line: 174
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 67,
            column: 2
          },
          end: {
            line: 71,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 67,
            column: 2
          },
          end: {
            line: 71,
            column: 3
          }
        }, {
          start: {
            line: 69,
            column: 9
          },
          end: {
            line: 71,
            column: 3
          }
        }],
        line: 67
      },
      "1": {
        loc: {
          start: {
            line: 69,
            column: 9
          },
          end: {
            line: 71,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 69,
            column: 9
          },
          end: {
            line: 71,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 69
      },
      "2": {
        loc: {
          start: {
            line: 92,
            column: 2
          },
          end: {
            line: 92,
            column: 24
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 92,
            column: 20
          },
          end: {
            line: 92,
            column: 24
          }
        }],
        line: 92
      },
      "3": {
        loc: {
          start: {
            line: 107,
            column: 25
          },
          end: {
            line: 107,
            column: 78
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 107,
            column: 43
          },
          end: {
            line: 107,
            column: 45
          }
        }, {
          start: {
            line: 107,
            column: 48
          },
          end: {
            line: 107,
            column: 78
          }
        }],
        line: 107
      },
      "4": {
        loc: {
          start: {
            line: 110,
            column: 4
          },
          end: {
            line: 116,
            column: 10
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 111,
            column: 8
          },
          end: {
            line: 111,
            column: 75
          }
        }, {
          start: {
            line: 112,
            column: 8
          },
          end: {
            line: 116,
            column: 10
          }
        }],
        line: 110
      },
      "5": {
        loc: {
          start: {
            line: 110,
            column: 4
          },
          end: {
            line: 110,
            column: 22
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 110,
            column: 4
          },
          end: {
            line: 110,
            column: 11
          }
        }, {
          start: {
            line: 110,
            column: 15
          },
          end: {
            line: 110,
            column: 22
          }
        }],
        line: 110
      },
      "6": {
        loc: {
          start: {
            line: 112,
            column: 8
          },
          end: {
            line: 116,
            column: 10
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 113,
            column: 8
          },
          end: {
            line: 113,
            column: 58
          }
        }, {
          start: {
            line: 114,
            column: 8
          },
          end: {
            line: 116,
            column: 10
          }
        }],
        line: 112
      },
      "7": {
        loc: {
          start: {
            line: 114,
            column: 8
          },
          end: {
            line: 116,
            column: 10
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 115,
            column: 8
          },
          end: {
            line: 115,
            column: 59
          }
        }, {
          start: {
            line: 116,
            column: 8
          },
          end: {
            line: 116,
            column: 10
          }
        }],
        line: 114
      },
      "8": {
        loc: {
          start: {
            line: 118,
            column: 4
          },
          end: {
            line: 120,
            column: 36
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 119,
            column: 8
          },
          end: {
            line: 119,
            column: 35
          }
        }, {
          start: {
            line: 120,
            column: 8
          },
          end: {
            line: 120,
            column: 36
          }
        }],
        line: 118
      },
      "9": {
        loc: {
          start: {
            line: 118,
            column: 4
          },
          end: {
            line: 118,
            column: 51
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 118,
            column: 4
          },
          end: {
            line: 118,
            column: 18
          }
        }, {
          start: {
            line: 118,
            column: 22
          },
          end: {
            line: 118,
            column: 51
          }
        }],
        line: 118
      },
      "10": {
        loc: {
          start: {
            line: 126,
            column: 27
          },
          end: {
            line: 126,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 126,
            column: 27
          },
          end: {
            line: 126,
            column: 36
          }
        }, {
          start: {
            line: 126,
            column: 40
          },
          end: {
            line: 126,
            column: 54
          }
        }],
        line: 126
      },
      "11": {
        loc: {
          start: {
            line: 132,
            column: 4
          },
          end: {
            line: 132,
            column: 24
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 132,
            column: 4
          },
          end: {
            line: 132,
            column: 11
          }
        }, {
          start: {
            line: 132,
            column: 15
          },
          end: {
            line: 132,
            column: 24
          }
        }],
        line: 132
      },
      "12": {
        loc: {
          start: {
            line: 139,
            column: 4
          },
          end: {
            line: 142,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 139,
            column: 4
          },
          end: {
            line: 142,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 139
      },
      "13": {
        loc: {
          start: {
            line: 145,
            column: 4
          },
          end: {
            line: 148,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 145,
            column: 4
          },
          end: {
            line: 148,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 145
      },
      "14": {
        loc: {
          start: {
            line: 147,
            column: 6
          },
          end: {
            line: 147,
            column: 42
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 147,
            column: 6
          },
          end: {
            line: 147,
            column: 18
          }
        }, {
          start: {
            line: 147,
            column: 22
          },
          end: {
            line: 147,
            column: 42
          }
        }],
        line: 147
      },
      "15": {
        loc: {
          start: {
            line: 151,
            column: 4
          },
          end: {
            line: 155,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 151,
            column: 4
          },
          end: {
            line: 155,
            column: 5
          }
        }, {
          start: {
            line: 153,
            column: 11
          },
          end: {
            line: 155,
            column: 5
          }
        }],
        line: 151
      },
      "16": {
        loc: {
          start: {
            line: 157,
            column: 4
          },
          end: {
            line: 157,
            column: 24
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 157,
            column: 4
          },
          end: {
            line: 157,
            column: 11
          }
        }, {
          start: {
            line: 157,
            column: 15
          },
          end: {
            line: 157,
            column: 24
          }
        }],
        line: 157
      },
      "17": {
        loc: {
          start: {
            line: 163,
            column: 32
          },
          end: {
            line: 163,
            column: 80
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 163,
            column: 32
          },
          end: {
            line: 163,
            column: 60
          }
        }, {
          start: {
            line: 163,
            column: 64
          },
          end: {
            line: 163,
            column: 80
          }
        }],
        line: 163
      },
      "18": {
        loc: {
          start: {
            line: 164,
            column: 31
          },
          end: {
            line: 164,
            column: 78
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 164,
            column: 31
          },
          end: {
            line: 164,
            column: 58
          }
        }, {
          start: {
            line: 164,
            column: 62
          },
          end: {
            line: 164,
            column: 78
          }
        }],
        line: 164
      },
      "19": {
        loc: {
          start: {
            line: 167,
            column: 4
          },
          end: {
            line: 170,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 167,
            column: 5
          },
          end: {
            line: 167,
            column: 17
          }
        }, {
          start: {
            line: 167,
            column: 21
          },
          end: {
            line: 167,
            column: 47
          }
        }, {
          start: {
            line: 168,
            column: 5
          },
          end: {
            line: 168,
            column: 12
          }
        }, {
          start: {
            line: 168,
            column: 16
          },
          end: {
            line: 168,
            column: 55
          }
        }, {
          start: {
            line: 169,
            column: 5
          },
          end: {
            line: 169,
            column: 12
          }
        }, {
          start: {
            line: 169,
            column: 16
          },
          end: {
            line: 169,
            column: 54
          }
        }, {
          start: {
            line: 170,
            column: 5
          },
          end: {
            line: 170,
            column: 21
          }
        }, {
          start: {
            line: 170,
            column: 25
          },
          end: {
            line: 170,
            column: 39
          }
        }],
        line: 167
      },
      "20": {
        loc: {
          start: {
            line: 172,
            column: 30
          },
          end: {
            line: 172,
            column: 74
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 172,
            column: 40
          },
          end: {
            line: 172,
            column: 67
          }
        }, {
          start: {
            line: 172,
            column: 70
          },
          end: {
            line: 172,
            column: 74
          }
        }],
        line: 172
      },
      "21": {
        loc: {
          start: {
            line: 175,
            column: 4
          },
          end: {
            line: 183,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 175,
            column: 4
          },
          end: {
            line: 183,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 175
      },
      "22": {
        loc: {
          start: {
            line: 180,
            column: 21
          },
          end: {
            line: 180,
            column: 42
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 180,
            column: 21
          },
          end: {
            line: 180,
            column: 31
          }
        }, {
          start: {
            line: 180,
            column: 35
          },
          end: {
            line: 180,
            column: 42
          }
        }],
        line: 180
      },
      "23": {
        loc: {
          start: {
            line: 188,
            column: 19
          },
          end: {
            line: 188,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 188,
            column: 19
          },
          end: {
            line: 188,
            column: 29
          }
        }, {
          start: {
            line: 188,
            column: 33
          },
          end: {
            line: 188,
            column: 40
          }
        }],
        line: 188
      },
      "24": {
        loc: {
          start: {
            line: 197,
            column: 9
          },
          end: {
            line: 208,
            column: 9
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 198,
            column: 10
          },
          end: {
            line: 205,
            column: 17
          }
        }, {
          start: {
            line: 207,
            column: 10
          },
          end: {
            line: 207,
            column: 15
          }
        }],
        line: 197
      },
      "25": {
        loc: {
          start: {
            line: 199,
            column: 36
          },
          end: {
            line: 199,
            column: 66
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 199,
            column: 56
          },
          end: {
            line: 199,
            column: 57
          }
        }, {
          start: {
            line: 199,
            column: 60
          },
          end: {
            line: 199,
            column: 66
          }
        }],
        line: 199
      },
      "26": {
        loc: {
          start: {
            line: 209,
            column: 9
          },
          end: {
            line: 216,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 209,
            column: 9
          },
          end: {
            line: 209,
            column: 26
          }
        }, {
          start: {
            line: 210,
            column: 10
          },
          end: {
            line: 215,
            column: 12
          }
        }],
        line: 209
      },
      "27": {
        loc: {
          start: {
            line: 219,
            column: 19
          },
          end: {
            line: 219,
            column: 37
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 219,
            column: 19
          },
          end: {
            line: 219,
            column: 28
          }
        }, {
          start: {
            line: 219,
            column: 32
          },
          end: {
            line: 219,
            column: 37
          }
        }],
        line: 219
      },
      "28": {
        loc: {
          start: {
            line: 225,
            column: 26
          },
          end: {
            line: 225,
            column: 70
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 225,
            column: 26
          },
          end: {
            line: 225,
            column: 40
          }
        }, {
          start: {
            line: 225,
            column: 45
          },
          end: {
            line: 225,
            column: 69
          }
        }],
        line: 225
      },
      "29": {
        loc: {
          start: {
            line: 225,
            column: 45
          },
          end: {
            line: 225,
            column: 69
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 225,
            column: 64
          },
          end: {
            line: 225,
            column: 65
          }
        }, {
          start: {
            line: 225,
            column: 68
          },
          end: {
            line: 225,
            column: 69
          }
        }],
        line: 225
      },
      "30": {
        loc: {
          start: {
            line: 227,
            column: 16
          },
          end: {
            line: 227,
            column: 58
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 227,
            column: 31
          },
          end: {
            line: 227,
            column: 51
          }
        }, {
          start: {
            line: 227,
            column: 54
          },
          end: {
            line: 227,
            column: 58
          }
        }],
        line: 227
      },
      "31": {
        loc: {
          start: {
            line: 232,
            column: 21
          },
          end: {
            line: 232,
            column: 52
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 232,
            column: 29
          },
          end: {
            line: 232,
            column: 38
          }
        }, {
          start: {
            line: 232,
            column: 41
          },
          end: {
            line: 232,
            column: 52
          }
        }],
        line: 232
      },
      "32": {
        loc: {
          start: {
            line: 250,
            column: 7
          },
          end: {
            line: 254,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 250,
            column: 7
          },
          end: {
            line: 250,
            column: 17
          }
        }, {
          start: {
            line: 251,
            column: 8
          },
          end: {
            line: 253,
            column: 15
          }
        }],
        line: 250
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0, 0, 0, 0, 0, 0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "e7cc423bb0924d239aec5f34a9a25cf9bea038f3"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_ot8arpjan = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_ot8arpjan();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
cov_ot8arpjan().s[0]++;
var ensureMoment = function ensureMoment(date) {
  cov_ot8arpjan().f[0]++;
  cov_ot8arpjan().s[1]++;
  if (_moment["default"].isMoment(date)) {
    cov_ot8arpjan().b[0][0]++;
    cov_ot8arpjan().s[2]++;
    return date;
  } else {
    cov_ot8arpjan().b[0][1]++;
    cov_ot8arpjan().s[3]++;
    if (date) {
      cov_ot8arpjan().b[1][0]++;
      cov_ot8arpjan().s[4]++;
      return (0, _moment["default"])(date);
    } else {
      cov_ot8arpjan().b[1][1]++;
    }
  }
};
cov_ot8arpjan().s[5]++;
var isWeekend = function isWeekend(day) {
  cov_ot8arpjan().f[1]++;
  cov_ot8arpjan().s[6]++;
  return day.day() % 6 === 0;
};

/**
 * The DatePicker component uses the `react-dates` library to render an input
 * and calendar that lets you select a single date. A note on props: Use
 * `minDate` (moment.Moment | Date) to specify the minimum allowable date. Use
 * `maxDate` (moment.Moment | Date) to specify the maximum allowable date. If
 * it's easier to express the dates that aren't allowed as a function, use
 * `isOutOfRange` instead. Optionally, use `initialDate` (moment.Moment | Date)
 * to pre-select a date.
 */
cov_ot8arpjan().s[7]++;
var DatePicker = function DatePicker(_ref) {
  var _ref11;
  var isOutOfRange = _ref.isOutOfRange,
    customIsOutOfRangeSRMessage = _ref.customIsOutOfRangeSRMessage,
    minDate = _ref.minDate,
    maxDate = _ref.maxDate,
    onDateChange = _ref.onDateChange,
    numberOfMonths = _ref.numberOfMonths,
    _ref$includeWeekends = _ref.includeWeekends,
    includeWeekends = _ref$includeWeekends === void 0 ? (cov_ot8arpjan().b[2][0]++, true) : _ref$includeWeekends,
    initialDate = _ref.initialDate,
    id = _ref.id,
    disabled = _ref.disabled,
    invalid = _ref.invalid,
    label = _ref.label,
    placeholder = _ref.placeholder,
    helperText = _ref.helperText,
    onClose = _ref.onClose,
    onClick = _ref.onClick,
    CustomPortalStyles = _ref.CustomPortalStyles,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_ot8arpjan().f[2]++;
  var _ref2 = (cov_ot8arpjan().s[8]++, (0, _react.useState)(ensureMoment(initialDate))),
    _ref3 = _slicedToArray(_ref2, 2),
    selectedDate = _ref3[0],
    setSelectedDate = _ref3[1];
  // ScreenReader message - we need to also include what date ranges are unavailable
  var weekendMessage = (cov_ot8arpjan().s[9]++, includeWeekends ? (cov_ot8arpjan().b[3][0]++, '') : (cov_ot8arpjan().b[3][1]++, 'Weekends are not available. '));
  var defaultIsOutOfRangeSRMessage = (cov_ot8arpjan().s[10]++, (cov_ot8arpjan().b[5][0]++, minDate) && (cov_ot8arpjan().b[5][1]++, maxDate) ? (cov_ot8arpjan().b[4][0]++, "Date must be between ".concat(minDate, " and ").concat(maxDate, ". ").concat(weekendMessage)) : (cov_ot8arpjan().b[4][1]++, minDate ? (cov_ot8arpjan().b[6][0]++, "Date must be after ".concat(minDate, ". ").concat(weekendMessage)) : (cov_ot8arpjan().b[6][1]++, maxDate ? (cov_ot8arpjan().b[7][0]++, "Date must be before ".concat(maxDate, ". ").concat(weekendMessage)) : (cov_ot8arpjan().b[7][1]++, ''))));
  var unavailableDateMessage = (cov_ot8arpjan().s[11]++, (cov_ot8arpjan().b[9][0]++, !!isOutOfRange) && (cov_ot8arpjan().b[9][1]++, !!customIsOutOfRangeSRMessage) ? (cov_ot8arpjan().b[8][0]++, customIsOutOfRangeSRMessage) : (cov_ot8arpjan().b[8][1]++, defaultIsOutOfRangeSRMessage));
  var SCREEN_READER_INPUT_MESSAGE = (cov_ot8arpjan().s[12]++, "Type the date in the specified format (Month date, Year) and use the arrow key to navigate forward to interact with the calendar and select a date. Press the keyboard shortcuts panel button to get the keyboard shortcuts for changing dates. ".concat(unavailableDateMessage));
  var _ref4 = (cov_ot8arpjan().s[13]++, (0, _useMedia.useDevice)()),
    isMobile = _ref4.isMobile;
  var isMediumScreen = (cov_ot8arpjan().s[14]++, (0, _useMedia["default"])('(min-width: 575px)'));
  var showTwoCalendars = (cov_ot8arpjan().s[15]++, (cov_ot8arpjan().b[10][0]++, !isMobile) && (cov_ot8arpjan().b[10][1]++, isMediumScreen));
  var _ref5 = (cov_ot8arpjan().s[16]++, (0, _react.useState)(false)),
    _ref6 = _slicedToArray(_ref5, 2),
    isFocused = _ref6[0],
    setIsFocused = _ref6[1];
  var _ref7 = (cov_ot8arpjan().s[17]++, (0, _react.useState)(false)),
    _ref8 = _slicedToArray(_ref7, 2),
    isDateUnavailable = _ref8[0],
    setisDateUnavailable = _ref8[1];
  cov_ot8arpjan().s[18]++;
  var handleFocusChange = function handleFocusChange(_ref9) {
    var focused = _ref9.focused;
    cov_ot8arpjan().f[3]++;
    cov_ot8arpjan().s[19]++;
    setIsFocused(focused);
    cov_ot8arpjan().s[20]++;
    (cov_ot8arpjan().b[11][0]++, onClick) && (cov_ot8arpjan().b[11][1]++, onClick());
  };
  var wrapperRef = (cov_ot8arpjan().s[21]++, (0, _react.useRef)());
  cov_ot8arpjan().s[22]++;
  var handleDateChange = function handleDateChange(date) {
    cov_ot8arpjan().f[4]++;
    cov_ot8arpjan().s[23]++;
    setSelectedDate(date);
    cov_ot8arpjan().s[24]++;
    if (date) {
      cov_ot8arpjan().b[12][0]++;
      cov_ot8arpjan().s[25]++;
      onDateChange(date.toDate());
      cov_ot8arpjan().s[26]++;
      setisDateUnavailable(false);
    } else {
      cov_ot8arpjan().b[12][1]++;
    }
    // Refocus the input element for a11y. This is different from `isFocused` because
    // the calendar should remain closed
    cov_ot8arpjan().s[27]++;
    if (wrapperRef.current) {
      cov_ot8arpjan().b[13][0]++;
      var inputElement = (cov_ot8arpjan().s[28]++, wrapperRef.current.querySelector('input'));
      cov_ot8arpjan().s[29]++;
      (cov_ot8arpjan().b[14][0]++, inputElement) && (cov_ot8arpjan().b[14][1]++, inputElement.focus());
    } else {
      cov_ot8arpjan().b[13][1]++;
    }
  };
  cov_ot8arpjan().s[30]++;
  var handleClose = function handleClose(_ref10) {
    var date = _ref10.date;
    cov_ot8arpjan().f[5]++;
    cov_ot8arpjan().s[31]++;
    if (!date) {
      cov_ot8arpjan().b[15][0]++;
      cov_ot8arpjan().s[32]++;
      setisDateUnavailable(true);
    } else {
      cov_ot8arpjan().b[15][1]++;
      cov_ot8arpjan().s[33]++;
      setisDateUnavailable(false);
    }
    cov_ot8arpjan().s[34]++;
    (cov_ot8arpjan().b[16][0]++, onClose) && (cov_ot8arpjan().b[16][1]++, onClose());
  };

  /**
   * NOTE: These methods aren't neatly exposed in an esm friendly way. Just extrapolating the logic here since the package is no longer maintained and we can't import the methods directly.
   */
  cov_ot8arpjan().s[35]++;
  var isBeforeDay = function isBeforeDay(a, b) {
    cov_ot8arpjan().f[6]++;
    cov_ot8arpjan().s[36]++;
    return (cov_ot8arpjan().b[17][0]++, (0, _index.isInclusivelyBeforeDay)(a, b)) && (cov_ot8arpjan().b[17][1]++, !(0, _index.isSameDay)(a, b));
  };
  cov_ot8arpjan().s[37]++;
  var isAfterDay = function isAfterDay(a, b) {
    cov_ot8arpjan().f[7]++;
    cov_ot8arpjan().s[38]++;
    return (cov_ot8arpjan().b[18][0]++, (0, _index.isInclusivelyAfterDay)(a, b)) && (cov_ot8arpjan().b[18][1]++, !(0, _index.isSameDay)(a, b));
  };
  cov_ot8arpjan().s[39]++;
  var isOutsideRange = function isOutsideRange(day) {
    cov_ot8arpjan().f[8]++;
    cov_ot8arpjan().s[40]++;
    return (cov_ot8arpjan().b[19][0]++, isOutOfRange) && (cov_ot8arpjan().b[19][1]++, isOutOfRange(day.toDate())) || (cov_ot8arpjan().b[19][2]++, minDate) && (cov_ot8arpjan().b[19][3]++, isBeforeDay(day, ensureMoment(minDate))) || (cov_ot8arpjan().b[19][4]++, maxDate) && (cov_ot8arpjan().b[19][5]++, isAfterDay(day, ensureMoment(maxDate))) || (cov_ot8arpjan().b[19][6]++, !includeWeekends) && (cov_ot8arpjan().b[19][7]++, isWeekend(day));
  };
  var initialVisibleMonth = (cov_ot8arpjan().s[41]++, minDate ? (cov_ot8arpjan().b[20][0]++, function () {
    cov_ot8arpjan().f[9]++;
    cov_ot8arpjan().s[42]++;
    return ensureMoment(minDate);
  }) : (cov_ot8arpjan().b[20][1]++, null));
  cov_ot8arpjan().s[43]++;
  var GlobalStyles = function GlobalStyles() {
    cov_ot8arpjan().f[10]++;
    cov_ot8arpjan().s[44]++;
    if (typeof CustomPortalStyles !== 'undefined') {
      cov_ot8arpjan().b[21][0]++;
      cov_ot8arpjan().s[45]++;
      return /*#__PURE__*/_react["default"].createElement(CustomPortalStyles, {
        isMobile: isMobile,
        isFocused: isFocused,
        isInvalid: (cov_ot8arpjan().b[22][0]++, !isFocused) && (cov_ot8arpjan().b[22][1]++, invalid)
      });
    } else {
      cov_ot8arpjan().b[21][1]++;
    }
    cov_ot8arpjan().s[46]++;
    return /*#__PURE__*/_react["default"].createElement(_GlobalPortalStyles.GlobalPortalStyles, {
      isMobile: isMobile,
      isFocused: isFocused,
      isInvalid: (cov_ot8arpjan().b[23][0]++, !isFocused) && (cov_ot8arpjan().b[23][1]++, invalid)
    });
  };
  cov_ot8arpjan().s[47]++;
  return /*#__PURE__*/_react["default"].createElement(_core.Box, {
    ref: wrapperRef
  }, /*#__PURE__*/_react["default"].createElement(GlobalStyles, null), /*#__PURE__*/_react["default"].createElement(_core.Flex, {
    flexDirection: "column"
  }, typeof label === 'string' ? (cov_ot8arpjan().b[24][0]++, /*#__PURE__*/_react["default"].createElement(_core.Flex, null, /*#__PURE__*/_react["default"].createElement(_core.Label, {
    htmlFor: id,
    pb: isDateUnavailable ? (cov_ot8arpjan().b[25][0]++, 0) : (cov_ot8arpjan().b[25][1]++, [2, 3])
  }, label), /*#__PURE__*/_react["default"].createElement(_core.Text, {
    pl: 3,
    color: "neutrals70"
  }, '(Month Day, Year)'))) : (cov_ot8arpjan().b[24][1]++, label), (cov_ot8arpjan().b[26][0]++, isDateUnavailable) && (cov_ot8arpjan().b[26][1]++, /*#__PURE__*/_react["default"].createElement(_ErrorPrompt.ErrorPrompt, {
    "aria-label": "Error message indicating that the date chosen is invalid or unavailable",
    message: "Please choose a valid date",
    mt: 0,
    mb: 3
  })), /*#__PURE__*/_react["default"].createElement(_index.SingleDatePicker, _extends({}, props, {
    focused: (_ref11 = (cov_ot8arpjan().b[27][0]++, isFocused)) !== null && _ref11 !== void 0 ? _ref11 : (cov_ot8arpjan().b[27][1]++, false),
    onClose: handleClose,
    onFocusChange: handleFocusChange,
    id: id,
    disabled: disabled,
    displayFormat: "MMMM D, YYYY",
    numberOfMonths: (cov_ot8arpjan().b[28][0]++, numberOfMonths) || (cov_ot8arpjan().b[28][1]++, showTwoCalendars ? (cov_ot8arpjan().b[29][0]++, 2) : (cov_ot8arpjan().b[29][1]++, 1)),
    weekDayFormat: 'dd',
    date: selectedDate ? (cov_ot8arpjan().b[30][0]++, (0, _moment["default"])(selectedDate)) : (cov_ot8arpjan().b[30][1]++, null),
    isOutsideRange: isOutsideRange,
    onDateChange: handleDateChange,
    initialVisibleMonth: initialVisibleMonth
    /* ariaLabel is redundant if label with `for` attribute exists */,
    ariaLabel: label ? (cov_ot8arpjan().b[31][0]++, undefined) : (cov_ot8arpjan().b[31][1]++, placeholder),
    placeholder: placeholder,
    screenReaderInputMessage: SCREEN_READER_INPUT_MESSAGE,
    customInputIcon: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.Icon, {
      name: "date-checked",
      "aria-hidden": isFocused
    }), /*#__PURE__*/_react["default"].createElement(_core.Box, {
      as: "span",
      className: "sr-only"
    }, "choose date")),
    inputIconPosition: "after",
    navPrev: /*#__PURE__*/_react["default"].createElement(_core.Icon, {
      name: "chevron-left",
      size: 16
    }),
    navNext: /*#__PURE__*/_react["default"].createElement(_core.Icon, {
      name: "chevron-right",
      size: 16
    }),
    withPortal: isMobile,
    readOnly: isMobile
  }))), (cov_ot8arpjan().b[32][0]++, helperText) && (cov_ot8arpjan().b[32][1]++, /*#__PURE__*/_react["default"].createElement(_core.Text, {
    as: "div",
    fontSize: "s1",
    mt: 3,
    mb: 0
  }, helperText)));
};
var _default = exports["default"] = DatePicker;